import { render, staticRenderFns } from "./CitizenGate.vue?vue&type=template&id=731165a6&"
import script from "./CitizenGate.vue?vue&type=script&lang=js&"
export * from "./CitizenGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports